import {
  NOTIFICATION_DETAIL_FAIL,
  NOTIFICATION_DETAIL_REQUEST,
  NOTIFICATION_DETAIL_SUCCESS,
} from "../constants/constants";

const initialState = {
  loading: true,
  NotifiactionDetail: [],
  length: 0,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case NOTIFICATION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        NotifiactionDetail: action.payload,
        length: action.notificationLength,
      };

    case NOTIFICATION_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        NotifiactionDetail: [],
        error: action.payload,
        length: 0,
      };

    default:
      return state;
  }
};
